/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import blue from '@material-ui/core/colors/blue';

import AddIcon from '@material-ui/icons/Add';
import COLORS from '../../assets/themes/OPL/colors';

const styles = (theme) => ({
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        backgroundColor: COLORS.MAIN.PRIMARY,
        color: COLORS.MAIN.LIGHT,
        '&:hover': {
            backgroundColor: COLORS.MAIN.SECONDARY,
        },
    },
});

class FabAddButton extends React.Component {
    render() {
        const { classes, callback, callbackParam, icon } = this.props;
        const fabStyle = {
            color: 'inherit',
            className: classNames(classes.fab),
            icon: icon ? icon : <AddIcon />,
        };
        return (
            <Fab className={fabStyle.className} color={fabStyle.color} onClick={() => callback(callbackParam)}>
                {fabStyle.icon}
            </Fab>
        );
    }
}

FabAddButton.propTypes = {
    classes: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(FabAddButton);
